import { get } from 'lodash'

import { Media } from "@skinsoft/types";

export const id = (media: Media) => get(media, 'id')
export const fileName = (media: Media) => {
    const res = get(media, "fileRecordCS.fileName")
    return res?.value ?? res
}